/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Patient Actions
 */

// Constants
import {
  GET_ALL_PATIENTS,
  CREATE_PATIENT,
  CREATE_PATIENT_OKTA,
  UPDATE_PATIENT,
  UPDATE_PATIENT_STATUS,
  GET_PATIENT_BY_ID,
  GET_PATIENT_BY_DOCUMENT,
  GET_EMAIL_PATIENT_BY_DOCUMENT,
  DELETE_PATIENT_BY_ID,
  GET_ALL_IDENTIFICATION_TYPES,
  GET_ALL_PATIENT_STATUS,
  GET_PATIENT_INDICATORS,
  GET_EVENTS_BY_PATIENT_ID,
  GET_FILTER_PATIENTS,
  GET_PATIENT_EXTRA_DATA_BY_ID,
  GET_PTH_PATIENT,
  GET_UPCOMING_VIDEO_CALLS,
  GET_LAST_APPOINTMENT,
  SEND_MASS_INVITATION,
  GET_LIST_PATIENT_M_PROCESSING,
  GET_PATIENT_M_DETAILS
} from './constants';

/**
 * Call process to get all patients list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PATIENTS
 */
export const getPatientsArray = (_, callback) => ({
  type: GET_ALL_PATIENTS,
  callback
});

/**
 * Call process to get patient by id
 * @param  { object } data - Patient Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getPatientById = (data, callback) => ({
  type: GET_PATIENT_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get patient last appointment by id Versia
 * @param  { object } data - Patient Id Versia
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getPatientLastAppointment = (data, callback) => ({
  type: GET_LAST_APPOINTMENT,
  payload: { data },
  callback
});

/**
 * Call process to get patient extra info by id
 * @param  { object } data - Patient Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getPatientExtraDataById = (data, callback) => ({
  type: GET_PATIENT_EXTRA_DATA_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get patient by document
 * @param  { object } data - Patient document
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getPatientByDocument = (data, callback) => ({
  type: GET_PATIENT_BY_DOCUMENT,
  payload: { data },
  callback
});

/**
 * Call process to get patient by document
 * @param  { object } data - Patient document
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ROL_BY_ID
 */
export const getEmailPatientByDocument = (data, callback) => ({
  type: GET_EMAIL_PATIENT_BY_DOCUMENT,
  payload: { data },
  callback
});

/**
 * Call process to create patient
 * @param  { object } data - Patient Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PATIENT
 */
export const createPatient = (data, callback) => ({
  type: CREATE_PATIENT,
  payload: { data },
  callback
});

/**
 * Call process to create patient in Okta
 * @param  { object } data - Patient Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PATIENT
 */
export const createPatientOkta = (data, callback) => ({
  type: CREATE_PATIENT_OKTA,
  payload: { data },
  callback
});

/**
 * Call process to update patient
 * @param  { object } data - Patient Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PATIENT
 */
export const updatePatient = (data, callback) => ({
  type: UPDATE_PATIENT,
  payload: { data },
  callback
});

/**
 * Call process to update patient STATUS
 * @param  { object } data - Patient Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_PATIENT_STATUS
 */
export const updatePatientStatus = (data, callback) => ({
  type: UPDATE_PATIENT_STATUS,
  payload: { data },
  callback
});

/**
 * Call process to delete patient
 * @param  { object } data - Patient Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_PATIENT_BY_ID
 */
export const deletePatientById = (data, callback) => ({
  type: DELETE_PATIENT_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get all identification types list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_IDENTIFICATION_TYPES
 */
export const getIdentificationTypesArray = (data, callback) => ({
  type: GET_ALL_IDENTIFICATION_TYPES,
  payload: { data },
  callback
});

/**
 * Call process to get all patient status
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PATIENT_STATUS
 */
export const getPatientStatusArray = (callback) => ({
  type: GET_ALL_PATIENT_STATUS,
  callback
});

/**
 * Call process to get patient indicator
 * @param  { object } data - PatientId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PATIENT_INDICATOR
 */
export const getPatientIndicators = (data, callback) => ({
  type: GET_PATIENT_INDICATORS,
  payload: { data },
  callback
});

/**
 * Call process to get patient indicator
 * @param  { object } data - PatientId
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_EVENTS_BY_PATIENT_ID
 */
export const getEventTypesByPatientId = (data, callback) => ({
  type: GET_EVENTS_BY_PATIENT_ID,
  payload: { data },
  callback
});

/**
 * Call process to get all patients list
 * @param  { object } data - Pagination Data and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_FILTER_PATIENTS
 */
export const getFilterPatients = (data, callback) => ({
  type: GET_FILTER_PATIENTS,
  payload: { data },
  callback
});

/**
 * Call process to get all patients list
 * @param  { object } data - pacient data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_PTH_PATIENT
 */
export const getPthPatient = (data, callback) => ({
  type: GET_PTH_PATIENT,
  payload: { data },
  callback
});

/**
 * Call process to get upcoming video calls
 * @param  { object } data - clinic data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_UPCOMING_VIDEO_CALLS
 */
export const getUpcomingVideoCalls = (data, callback) => ({
  type: GET_UPCOMING_VIDEO_CALLS,
  payload: { data },
  callback
});

/**
 * Call process to get upcoming video calls
 * @param  { object } data - PATIENTS data
 * @param  { function } callback - Response callback
 * @return { object } An action object with ???
 */
export const sendMassInvitation = (data, callback) => ({
  type: SEND_MASS_INVITATION,
  payload: { data },
  callback
});

/**
 * Call process to get upcoming video calls
 * @param  { function } callback - Response callback
 * @return { object } An action object with ???
 */
export const listPatientMProcessing = (_, callback) => {
  return {
    type: GET_LIST_PATIENT_M_PROCESSING,
    callback
  };
};

/**
 * Call process to get upcoming video calls
 * @param  { object } data - PATIENTS data
 * @param  { function } callback - Response callback
 * @return { object } An action object with ???
 */
export const patientMProcessDetail = (data, callback) => ({
  type: GET_PATIENT_M_DETAILS,
  payload: { data },
  callback
});
